
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="select_mail_addresses_dialog create-tag-dialog">
  <div class="select-mail-addresses__dialog-header" layout="row center-center">
    <div class="mobile-back-button" [fxHide.gt-sm]="true">
      <button (click)="close()" class="brand-color mat-button">
        <mat-icon class="disable-select">chevron_left</mat-icon>
      </button>
    </div>
    <div class="header-text">{{ 'SELECT_ADDRESSES' | translate}}</div>
    <div class="desktop-close-button">
       <div class="header-icon" (click)="close()" matTooltip="{{ 'CLOSE' | translate }}">
            <ng-container [ngTemplateOutlet]="closeIcon"></ng-container>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="contact-loading-spinner" *ngIf="isLoading">
      <vp-custom-spinner></vp-custom-spinner>
    </div>
    <div class="select-option-toggle-group">
        <button (click)="onValChange('To')" [class.toggle-checked]="selectedVal === 'To'">
            <span>{{'TO_MAIL_LABLE' | translate}}</span>
        </button>
        <button (click)="onValChange('Cc')" [class.toggle-checked]="selectedVal === 'Cc'">
            <span>{{'CC_MAIL_LABLE' | translate}}</span>
        </button >
        <button (click)="onValChange('Bcc')" [class.toggle-checked]="selectedVal === 'Bcc'">
            <span>{{'BCC_MAIL_LABLE' | translate}}</span>
        </button>
    </div>
    <div class="search-part">
        <div class="search">
            <mat-form-field>
                <input matInput placeholder="{{'SEARCH_DOT' | translate}}" [formControl]="searchControl" autocomplete="nope"/>
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
        <div class="dropdown">
            <mat-form-field>
                <mat-label>{{'SEARCH_IN' | translate }}:</mat-label>
                <mat-select *ngIf="!configService.useVNCdirectoryAuth" panelClass="show-name-select" (selectionChange)="resetOffset();changeShowNames($event.value)" [(ngModel)]="selectedShowOption" vpScrollList (onUserScroll)="scrollMoreContacts($event)">
                  <mat-option class="setting-dropdown-option" [value]="'contacts'">{{ 'CONTACTS' | translate }}</mat-option>
                  <mat-option class="setting-dropdown-option" [disabled]="!isOnline" [value]="'personalandshared'">{{ 'PERSONAL_AND_SHARED_CONTACTS' | translate }}</mat-option>
                  <mat-option class="setting-dropdown-option" [disabled]="!isOnline" *ngIf="iszimbraFeatureGalEnabled" [value]="'global'">{{ 'GLOBAL_ADDRESS_LIST' | translate }}</mat-option>
                </mat-select>
                <mat-select [disabled]="!isOnline" *ngIf="configService.useVNCdirectoryAuth" panelClass="show-name-select" (selectionChange)="resetOffset();getContactsFromList($event.value)" [(ngModel)]="selectedShowOption" vpScrollList (onUserScroll)="scrollMoreContacts($event)">
                  <mat-option class="setting-dropdown-option" [value]="0">{{ 'ALL' | translate }}</mat-option>
                  <mat-option class="setting-dropdown-option" *ngFor="let item of contactsList" [value]="item.id">{{ item.name }}</mat-option>
                  <mat-option class="setting-dropdown-option" [disabled]="!isOnline" *ngIf="iszimbraFeatureGalEnabled" [value]="'global'">{{ 'GLOBAL_ADDRESS_LIST' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="!!finalEmailAddresses && finalEmailAddresses.length > 0" class="all-selected-item">
        <div *ngFor="let contactItem of finalEmailAddresses" class="selected-contact-item">
          <div>
            <div class="type-label">
              <span class="type-txt" *ngIf="contactItem.t === 'To'">{{'TO_MAIL_LABLE' | translate}}</span>
              <span class="type-txt" *ngIf="contactItem.t === 'Cc'">{{'CC_MAIL_LABLE' | translate}}</span>
              <span class="type-txt" *ngIf="contactItem.t === 'Bcc'">{{'BCC_MAIL_LABLE' | translate}}</span>
            </div>
            <div class="close-icon" (click)="removeSelectedAddresses(contactItem)">
              <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-close"></mat-icon>
            </div>
            <div class="avatar-part">
              <vp-avatar [type]="'mail-detail-avatar'"
                [user]="{firstLastCharacters: contactItem.name.charAt(0), color: '#317bbc', email: contactItem.email}">
              </vp-avatar>
            </div>
          </div>
          <div class="name">
              {{contactItem.name}}
          </div>
        </div>
    </div>
    <div class="contact-items">
      <mat-list [ngClass]="{'is-contact-select': finalEmailAddresses.length > 0}" vpScrollList (onUserScroll)="scrollMoreContacts($event)">
        <mat-list-item *ngFor="let contact of allEmailAddresses; index as i;" (click)="selectContactItem(contact, i, $event)">
          <span class="user-avatar">
              <vp-avatar [type]="'mail-detail-avatar'"
                [user]="{firstLastCharacters: contact.name.charAt(0), color: '#317bbc', email: contact.email}">
              </vp-avatar>
          </span>
          <div class="contact-detail-part">
            <div class="fullname disable-select">{{contact.name}}</div>
            <div class="email-address disable-select">{{ contact.email}}</div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
  <div class="contact__dialog-footer" [ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid)}">
      <div class="desktop-footer">
          <button mat-button (click)="close()">
              {{ 'CANCEL' | translate }}
          </button>
          <button mat-button (click)="setSelected()">
              {{ 'SELECT_MENU_ITEM' | translate }}
          </button>
      </div>
  </div>
</div>
<ng-template #closeIcon>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/close-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M18.9497475,5.05025253 C19.3402718,5.44077682 19.3402718,6.0739418 18.9497475,6.46446609 L13.4142136,12 L18.9497475,17.5355339 C19.3402718,17.9260582 19.3402718,18.5592232 18.9497475,18.9497475 C18.5592232,19.3402718 17.9260582,19.3402718 17.5355339,18.9497475 L12,13.4142136 L6.46446609,18.9497475 C6.0739418,19.3402718 5.44077682,19.3402718 5.05025253,18.9497475 C4.65972824,18.5592232 4.65972824,17.9260582 5.05025253,17.5355339 L10.5857864,12 L5.05025253,6.46446609 C4.65972824,6.0739418 4.65972824,5.44077682 5.05025253,5.05025253 C5.44077682,4.65972824 6.0739418,4.65972824 6.46446609,5.05025253 L12,10.5857864 L17.5355339,5.05025253 C17.9260582,4.65972824 18.5592232,4.65972824 18.9497475,5.05025253 Z" id="Path" fill="#8B96A0"></path>
      </g>
    </svg>
</ng-template>